<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="10" class="mx-auto mb-3">
        <h1 class="my-8 main-title">
          Formulário de Incidentes ou Vazamento de Dados
        </h1>

        <v-card elevation="3" rounded class="px-8 pb-4 border-blue mb-8">
          <v-card-title class="section-title pt-8">
            Preencha todos os campos obrigatórios marcados com *.
          </v-card-title>
          <v-card-text>
            <v-form ref="incidentForm" v-model="formValid" class="main-text">
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="report.name"
                    label="Nome"
                    color="#173c94"
                    outlined
                    clearable
                    prepend-inner-icon="mdi-account"
                    hint="Opcional"
                    persistent-hint
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="report.date"
                    v-mask="'##/##/####'"
                    color="#173c94"
                    placeholder="dd/mm/aaaa"
                    label="Data do Incidente *"
                    prepend-inner-icon="mdi-calendar"
                    outlined
                    :rules="$rules.required.concat($rules.dateBr)"
                    hint="Formato: dd/mm/aaaa (ex.: 05/09/2025)"
                    persistent-hint
                    validate-on-blur
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="report.hour"
                    v-mask="'##:##'"
                    color="#173c94"
                    label="Hora do Incidente"
                    outlined
                    placeholder="HH:MM"
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    hint="Formato 24h (ex.: 14:30)"
                    persistent-hint
                    clearable
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="report.location"
                    label="Local / Unidade *"
                    color="#173c94"
                    outlined
                    :rules="$rules.required"
                    prepend-inner-icon="mdi-map-marker"
                    validate-on-blur
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="report.description"
                    label="Descrição do Incidente *"
                    color="#173c94"
                    outlined
                    rows="4"
                    auto-grow
                    :rules="$rules.required.concat($rules.min10Text)"
                    prepend-inner-icon="mdi-text-box"
                  />
                </v-col>

                <v-col cols="12" class="text-right mt-2">
                  <v-btn
                    color="secondary"
                    x-large
                    :disabled="!formValid"
                    :loading="loading"
                    @click="submitForm"
                  >
                    Enviar
                    <v-icon class="ml-4">
                      mdi-send
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
import PrivacyPortal from "../../services/privacy-portal";

export default {
  name: "ReportIncidentForm",
  directives: { mask },
  data() {
    return {
      formValid: false,
      report: {
        name: "",
        date: "",
        hour: "",
        location: "",
        description: "",
      },
      loading: false,
    };
  },
  methods: {
    async submitForm() {
      if (!this.$refs.incidentForm.validate()) return;

      this.loading = true;
      await PrivacyPortal.sendReportIncidentEmail(this.report)
        .then((response) =>
          this.$toast.success("Mensagem enviada com sucesso!")
        )
        .catch((error) =>
          this.$toast.error(
            "Ocorreu um erro ao tentar enviar a mensagem. Tente novamente mais tarde."
          )
        )
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.border-blue {
  border: 1px solid #173c94;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  color: #173c94;
}

.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #173c94;
  margin-bottom: 0.5rem;
}

.main-text {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  margin-bottom: 1.2rem;
}
</style>
